export class OrgNodeType{
    public static readonly ROTARYCLUB:number = 1;
    public static readonly DISTRICT:number = 2;
    public static readonly ZONE:number = 3;
    public static readonly ROTARACTCLUB:number = 4;
    public static readonly INTERACTCLUB:number = 5;
    public static readonly CLUBGROUPING:number = 6;
    public static readonly REGIONALGROUP:number = 7;
    public static readonly ROOT:number = 8;
    public static readonly ZONESECTION:number = 9;

    public OrgNodeTypeId:number;
    public Name:string;
    public Description:string;
    public SortOrder:number;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/entities/org-node-type.ts